define('pages/ad_form/ad_form_page_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  'modules/ad_form/ad_form_view',

  'modules/modal/modal_view',
  './copy_ad_modal_view',
  'modules/loading/loading_spinner_view',
  'text!./ad_form_page_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  AdFormView,
  ModalView,
  CopyAdModalView,
  Loading,
  ad_form_page_template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

			if (window.screen.width < 1920) {
				_.bindAll(this, 'detect_scroll');
				$(window).scroll(this.detect_scroll);
				this.prevScrollpos = window.pageYOffset;
			}

      this.subViews = [];

      var that = this;

      this.ad_form = new AdFormView({
        ad_id: this.ad_id,
        template_id: this.params && this.params.template_id,
        zone_id: this.params && this.params.zone_id,
        is_campaign: this.is_campaign,
        player_id: this.params && this.params.player_id,
      });
      this.subViews.push(this.ad_form);

      this.listenTo(
        this.ad_form.formModel,
        'enable_copy_button',
        function () {
          this.enableCopyButton();
        },
        this
      );

      this.listenTo(
        this.ad_form.formModel,
        'sync',
        function () {
          if (that.loading) {
            that.loading.done();
          }
        },
        this
      );

      this.render();

      this.renderSubView();

      this.loading = new Loading();
      this.loading.start();
    },

    template: _.template(ad_form_page_template),
    subViews: [],
    showInfoText: true,

    events: {
      'click .js-switch-view': 'switchView',
      'click .js-copy-ad': 'showCopyAdModal',
      'click .js-toggle-infotext': 'toggleInfoText',
    },

    toggleInfoText: function () {
      this.showInfoText = !this.showInfoText;

      if (this.showInfoText) {
        this.$('.icon.icon-chevron-up').removeClass('hide');
        this.$('.icon.icon-chevron-down').addClass('hide');
        this.$('.panel-info-text').removeClass('hide');
        this.$('.page-actions').removeClass('is-top');
      } else {
        this.$('.icon.icon-chevron-up').addClass('hide');
        this.$('.icon.icon-chevron-down').removeClass('hide');
        this.$('.panel-info-text').addClass('hide');
        this.$('.page-actions').addClass('is-top');
      }
    },

    render: function () {
      this.$el.html(this.template());

      if (this.ad_id) {
        this.enableCopyButton();
      }

      if (this.is_campaign) {
        this.$('.js-copy-ad').addClass('hide');
      }

      return this;
    },

    renderSubView: function () {
      this.$('.ad-form-page-content').html(this.ad_form.$el);
      // To get text as html.
      this.$('#infotext').html(_.t('ad_form_template.infotext'));
    },

    enableCopyButton: function () {
      this.$('.js-copy-ad')
        .attr('disabled', false)
        .attr('title', _.t('edit.button.copy_ad'));
    },

    switchView: function (e) {
      var view = $(e.currentTarget).data('view');
      e.preventDefault();

      this.$('.js-switch-view').removeClass('active');
      $(e.currentTarget).addClass('active');

      this.ad_form.switchView(view);
    },

    showCopyAdModal: function (e) {
      e.preventDefault();

      var mediaModal = new ModalView({
        title: _.t('modal.header.copy_ad'),
        modalContent: new CopyAdModalView(),
      });

      mediaModal.open();

      this.listenTo(mediaModal.modalContent, 'copyAd', function () {
        this.copyAd();
      });
    },

    copyAd: function () {
      $.ajax({
        type: 'GET',
        contentType: 'application/json; charset=UTF-8',
        url:
          session.get('apiUrl') +
          'htmladlocation/' +
          this.ad_form.formModel.get('id') +
          '/copy',
      }).success(
        function (data) {
          this.ad_form.remove();
          this.ad_form = new AdFormView({
            ad_id: data.id,
          });
          this.subViews.push(this.ad_form);
          this.renderSubView();
        }.bind(this)
      );
    },

    detect_scroll: function () {
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (this.prevScrollpos > currentScrollPos && currentScrollPos !== 0) {
          this.$('.ad-form-footer').hide();
        } else {
          this.$('.ad-form-footer').show();
        }
        this.prevScrollpos = currentScrollPos;
      };
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

